import React, { Component } from "react";
import Link, { LinkTo } from '../../PageLayout/Link/Link';
import { Breadcrumb, Button, Row, Col } from 'react-bootstrap';
import MainPagesLayout from '../../PageLayout/MainPagesLayout/MainPagesLayout';
import ProjectRequestCreationList from "../../Pages/Home/component/ProjectRequestCreationList";
import UserService from '../../Services/UserService';
import ApiService from '../../Services/ApiService';
import Loading from '../../PageLayout/Loading';
import ClassicTitledTile from '../Project/component/ClassicTitledTile';
//import ProjectDescriptionTile from './component/ProjectDescriptionTile';
import ProjectCarouselItem from './component/ProjectCarouselItem';
import ProjectSearchResult from "../Project/ProjectSearchResult";
import Spinner from '../../PageLayout/Spinner';
import toStart from 'images/toStart.svg';
import logo from "images/codai.svg";
import { Icon } from '@fluentui/react/lib/Icon';
import Carousel from 'react-bootstrap/Carousel';
class Home extends Component {
  constructor() {
    super();
    this.state = {
      IsUserDataScientist: false,
      IsUserAdmin: false,
      currentUserRequest: [],
      allRequest: [],
      featuredProject: [],

      isLoading: true,
      isFeaturedProjectLoading: true,
      isMyFavouriteLoading: true
    };
  }

  componentDidMount() {
    const requests = [
      UserService.IsUserDataScientist(),
      ApiService.createProjectRequestListMine(),
      UserService.IsUserAdmin(),
      ApiService.getProjectGlobalStarred()
    ];

    Promise.all(requests).then((data) => {
      let stateUpdate = {
        IsUserDataScientist: data[0],
        currentUserRequest: data[1],
        isLoading: false,
        isMyFavouriteLoading: false,
        isFeaturedProjectLoading: false,
        featuredProject: data[3]
      };

      if (data[2]) { // set as admin later in promises
        ApiService.createProjectRequestListAll()
          .then(data => {
            this.setState({
              IsUserAdmin: true,
              allRequest: data
            });
          });
      }
      UserService.subscribePrefProjects(this.handleMyPrefsUpdated);
      this.setState(stateUpdate);
    });
  }

  componentWillUnmount() {
    UserService.unsubscribePrefProjects(this.handleMyPrefsUpdated);
  }

  handleMyPrefsUpdated = () => {
    this.setState({ isFeaturedProjectLoading: true, isMyFavouriteLoading: true }, () => {
      //Change state to force "my favorites earch result" component to be reloaded
      this.setState({ isMyFavouriteLoading: false });
      ApiService.getProjectGlobalStarred().then(data => {
        this.setState({ isFeaturedProjectLoading: false, featuredProject: data });
      });
    });
  }

  render() {
    const toStartFullWidth = !this.state.IsUserAdmin && !this.state.IsUserDataScientist;
    let homePage;

    if (this.state.isLoading) {
      homePage = (<Loading />);
    } else {
      homePage = (
        <div>
          {this.state.featuredProject.length > 0 && (
            <div className="projectCarousel">
              {this.state.isFeaturedProjectLoading ? <div><Spinner />{"\tSearching featured project..."}</div> : (
                <Carousel interval={2500}>
                  {this.state.featuredProject.slice(0, 5).map((featuredProject) => {
                    return (
                      <Carousel.Item>
                        <ProjectCarouselItem project={featuredProject.project}></ProjectCarouselItem>
                      </Carousel.Item>
                    );
                  })}
                </Carousel>
              )}
            </div>
          )}
          <div>
            <Row>
              {!toStartFullWidth && (
                <Col md={7}>
                  <ClassicTitledTile title={(<h3 className="bigTitledTile">My creation requests</h3>)}>
                    <ProjectRequestCreationList projectCreationRequests={this.state.currentUserRequest} cancelable={true} />
                  </ClassicTitledTile>
                  {(this.state.IsUserAdmin && this.state.allRequest) && (
                    <ClassicTitledTile title={(<h3 className="bigTitledTile">All creation requests</h3>)}>
                      <ProjectRequestCreationList projectCreationRequests={this.state.allRequest} cancelable={false} />
                    </ClassicTitledTile>
                  )}
                </Col>
              )}
              <Col md={toStartFullWidth ? 12 : 5}>
                <ClassicTitledTile title={(<h3 className="bigTitledTile">To start...</h3>)}>
                  <Row>
                    <Col md={6}>
                      <img alt='to start' src={toStart} />
                    </Col>
                    <Col md={6}>
                      <p style={{ textIndent: "0" }}>
                        {"You can search for any public project through the search function of the portal."}
                      </p>
                      <p style={{ textIndent: "0" }}>

                        {(this.state.IsUserDataScientist) ?
                          ('You want to create a new project? Fill the simple creation request form!')
                          : ('To create a new project, please contact first the admin group')}

                        <span className="glyphicon glyphicon-hand-right"></span>
                      </p>
                      {(this.state.IsUserDataScientist) && (
                        <Link to={"/project/request/create"}>
                          <Button>
                            <span style={{ marginRight: "10px", fontSize: 23 }}>
                              <Icon iconName="CircleAddition" />
                            </span>
                            <span class="align-top">Request a new project</span>
                          </Button>
                        </Link>
                      )}
                    </Col>
                  </Row>
                </ClassicTitledTile>
              </Col>
            </Row>
          </div>
          <ClassicTitledTile title={(
            <h3 className="bigTitledTile">
              {"My favourites"}
              <Button className="viewAllButton" variant="outline-primary" {...LinkTo(`/project/search?requesterStar=true`)}>{'View all'}</Button>
            </h3>
          )}>
            {this.state.isMyFavouriteLoading ? <Spinner /> : (
              <ProjectSearchResult showLoading={true} search={{ limit: 4, requesterStar: true }} />
            )}
          </ClassicTitledTile>
          <ClassicTitledTile title={(
            <h3 className="bigTitledTile">
              {"Recently added"}
              <Button className="viewAllButton" variant="outline-primary" {...LinkTo(`/project/search?orderBy=createdAt`)}>{'View all'}</Button>
            </h3>
          )}>
            <ProjectSearchResult showLoading={true} search={{ limit: 4, orderBy: 'createdAt' }} />
          </ClassicTitledTile>
        </div>
      );
    }

    return (
      <MainPagesLayout className='HomePage'>
        <Breadcrumb className={'breadCrumb'}>
          <Breadcrumb.Item {...LinkTo('/')}>
            <img alt="CoDAI" src={logo} />
          </Breadcrumb.Item>
          <Breadcrumb.Item active>
            {'Home'}
          </Breadcrumb.Item>
          <Breadcrumb.Item className='breadcrumbItemRight' active>
            {'Popular projects'}
          </Breadcrumb.Item>
        </Breadcrumb>
        {homePage}
      </MainPagesLayout>
    );
  }
}
export default Home;
